module.exports = __webpack_public_path__ + "static/media/profile-picture-4.feacbe49.jpg";